import { Card, CardBody, Col } from "reactstrap";
import { P } from "../../../AbstractElements";
import { AnimationTitle } from "../../../Constants/Constants";
import { AnimationSubTitle } from "../../../Data/UiKits/Placeholders";
import CommonCardHeader from "../../CommonComponents/CommonCardHeader/CommonCardHeader";

const Animation = () => {
  return (
    <Col md="6">
      <Card>
        <CommonCardHeader title={AnimationTitle} span={AnimationSubTitle} />
        <CardBody className="animation-placeholder">
          <P className="placeholder-glow"><Col xs="12"><span className="placeholder placeholder-light w-100"/></Col></P>
          <P className="placeholder-wave"><Col xs="12"><span className="placeholder placeholder-light w-100"/></Col></P>
        </CardBody>
      </Card>
    </Col>
  );
};

export default Animation;
